// Webibazaar Cart Dropdown Code Start
function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
class WebiQuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }
  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    // Fire a NEW change event each time — Event objects can only be dispatched once per spec.
    if (previousValue !== this.input.value) {
      this.input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
}
customElements.define('webi-quantity-input', WebiQuantityInput);

class WebiCartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      this.closest('webi-cart-items').updateQuantity(this.dataset.index, 0);
    });
  }
}
customElements.define('webi-cart-remove-button', WebiCartRemoveButton);

class WebiCartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status');
    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, webiquantityInput) => total + parseInt(webiquantityInput.value), 0);
    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);
    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }
  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'), event.target.dataset.productId, event.target.dataset.isDrawer);
  }
  getSectionsToRender() {
    return [
      {
        id: 'webi-main-cart-items',
        section: document.getElementById('webi-main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      /* Removed cart-icon-bubble — its innerHTML replacement destroyed
         Bootstrap dropdown state + free-shipping-bar after item delete.
         Cart badge + drawer hydration handled by cart-notification.js's
         refreshCartBadge() instead. */
      {
        id: 'webi-cart-live-region-text',
        section: 'webi-cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'webi-main-cart-footer',
        section: document.getElementById('webi-main-cart-footer').dataset.id,
        selector: '.js-contents',
      }
    ];
  }
  updateQuantity(line, quantity, name, productId, isDrawer) {
    quantity = parseFloat(quantity);

    const maxQuantity = document.querySelector(
      `.hidden__temp--${productId}`
    );

    const btnCheckout = document.getElementById('checkout')
    this.enableLoading(line);

    const data = {
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    }

    // Cap to max_quantity ONLY if metafield is a valid positive number
    const maxRaw = maxQuantity && maxQuantity.textContent ? maxQuantity.textContent.trim() : '';
    const maxQuantityFormat = maxRaw ? parseFloat(maxRaw) : NaN;
    if (!isNaN(maxQuantityFormat) && maxQuantityFormat > 0 && quantity > maxQuantityFormat) {
      data.quantity = maxQuantityFormat;
    }

    let body = JSON.stringify(data);

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        // INVARIANT (bug-prevention 2026-06-04): /cart/change.js must return
        // CART STATE with a numeric item_count. On a bad shape (HTML error
        // page, throttle JSON, null) do not write badge/total/sections with
        // garbage — log + bail (the .finally still clears loading).
        if (!parsedState || typeof parsedState.item_count !== 'number') {
          if (window.console && console.warn) console.warn('[wbcartdropdown] updateQuantity: bad cart response shape, skipping UI write', parsedState);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartFooter = document.getElementById('webi-main-cart-footer');
        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);

        /* Update cart icon badge + total FIRST (must always run, even if a
           section render below fails). cart-icon-bubble section was removed
           from getSectionsToRender to preserve drawer open state. */
        const countEl = document.getElementById('Cartcount');
        if (countEl) countEl.textContent = parsedState.item_count;
        const totalEl = document.getElementById('CartTotalText');
        if (totalEl) {
          // BUG-H: /cart/change.js returns an inflated total_price (~+$10.99
          // phantom) for 200-400ms before /cart.js settles; items_subtotal_price
          // (= sum of line_prices) is correct. Use it so the /cart-page qty
          // change doesn't flash the ghost total. Same fix as card-stepper.js.
          const reliableTotal =
            typeof parsedState.items_subtotal_price === 'number' ? parsedState.items_subtotal_price :
            typeof parsedState.original_total_price === 'number' ? parsedState.original_total_price :
            parsedState.total_price;
          // INVARIANT (bug-prevention 2026-06-04): never paint a non-number total.
          if (!(typeof reliableTotal === 'number' && reliableTotal >= 0)) {
            if (window.console && console.warn) console.warn('[wbcartdropdown] updateQuantity: bad total, leaving header total unchanged', parsedState);
          } else if (window.Shopify && window.Shopify.formatMoney) {
            totalEl.innerHTML = window.Shopify.formatMoney(
              reliableTotal,
              window.Shopify.money_format || '${{amount}}'
            );
          } else {
            totalEl.textContent = '$' + (reliableTotal / 100).toFixed(2);
          }
        }
        document.dispatchEvent(new CustomEvent('cart:updated'));

        this.getSectionsToRender().forEach((section => {
          try {
            const html = parsedState.sections && parsedState.sections[section.section];
            if (!html) return;
            const target = document.getElementById(section.id);
            if (!target) return;
            const elementToReplace = target.querySelector(section.selector) || target;
            /* Scope the selector to the section ID so footer doesn't accidentally
               grab the items-list .js-contents (header has 2 .js-contents divs). */
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const newContent = doc.querySelector('#' + section.id + ' ' + section.selector)
                            || doc.querySelector(section.selector);
            if (!newContent) return;
            elementToReplace.innerHTML = newContent.innerHTML;
          } catch (e) { /* keep going on other sections */ }
        }));

        if (!isNaN(maxQuantityFormat) && maxQuantityFormat > 0 && quantity > maxQuantityFormat) {
          const showError = document.querySelector(`.show__err--${productId}`);
          if (showError) {
            showError.style.display = 'block';
            const msg = isDrawer ? `Limit of ${maxQuantityFormat} for order` : `Limit of ${maxQuantityFormat} for order, check in cart`;
            showError.innerHTML = msg;
          }
        }

        this.updateLiveRegions(line, parsedState.item_count);

        const lineItem = document.getElementById(`WbCartItem-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) lineItem.querySelector(`[name="${name}"]`).focus();

       
      }).catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
      }).finally(() => {
        this.disableLoading();
      });
  }
  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      document.getElementById(`Wb-Line-item-error-${line}`)
        .querySelector('.wb-cart-item__error-text')
        .innerHTML = window.cartStrings.quantityError.replace(
          '[quantity]',
          document.getElementById(`WbQuantity-${line}`).value
        );
    }
    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);
    const cartStatus = document.getElementById('webi-cart-live-region-text');
    cartStatus.setAttribute('aria-hidden', false);
    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }
  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  modifyHTMLInputWithRegex(htmlString) {
    // Thực hiện thay thế bằng regex
    const modifiedHTMLString = htmlString.replace(/<input class=\\"quantity__input\\"([^>]*)>/g, '<input class=\\"quantity__input\\" id="123"$1>');

    return modifiedHTMLString;
  }

  enableLoading(line) {
    document.getElementById('webi-main-cart-items').classList.add('cart__items--disabled');
    this.querySelectorAll(`#WbCartItem-${line} .loading-overlay`).forEach((overlay) => overlay.classList.remove('hidden'));
    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }
  disableLoading() {
    document.getElementById('webi-main-cart-items').classList.remove('cart__items--disabled');
  }
}
customElements.define('webi-cart-items', WebiCartItems);
// Webibazaar Cart Dropdown Code End
